export const container = `
  p-4 bg-base-white rounded z-10
  absolute top-12 right-0
  w-[300px] shadow-3sm
  overflow-hidden min-h-0

  data-[is-slider-open=true]:min-h-96
`;

export const content = `
  relative
`;
